import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchByUser",
  async ({ utilisateurId, page = 1, limit = 20, append = false }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/notifications/utilisateur/${utilisateurId}?page=${page}&limit=${limit}`);
      return { data, append, page };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement");
    }
  }
);

export const clearAllNotifications = createAsyncThunk(
  "notifications/clearAll",
  async (utilisateurId, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/notifications/clear/${utilisateurId}`);
      return utilisateurId;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur suppression");
    }
  }
);

export const markAsRead = createAsyncThunk(
  "notifications/markAsRead",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.patch(`/notifications/${id}/lu`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur");
    }
  }
);

export const markAllAsRead = createAsyncThunk(
  "notifications/markAllAsRead",
  async (utilisateurId, { rejectWithValue }) => {
    try {
      await axiosInstance.patch(`/notifications/utilisateur/${utilisateurId}/tout-lire`);
      return utilisateurId;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur");
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState: { list: [], loading: false, error: null, page: 1, hasMore: true },
  reducers: {
    clearNotificationMessages: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending,   (state) => { state.loading = true; })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        const { data, append, page } = action.payload;
        const list = Array.isArray(data) ? data : (data.data || []);
        if (append) {
          state.list = [...state.list, ...list];
        } else {
          state.list = list;
        }
        state.page = page;
        state.hasMore = Array.isArray(data) ? list.length >= 20 : (data?.page || 1) < (data?.pages || 1);
      })
      .addCase(fetchNotifications.rejected,  (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(clearAllNotifications.fulfilled, (state) => { state.list = []; state.page = 1; state.hasMore = true; })
      .addCase(markAsRead.fulfilled, (state, action) => {
        const id = action.payload;
        const n = state.list.find((n) => n._id === id);
        if (n) n.lu = true;
      })
      .addCase(markAllAsRead.fulfilled, (state) => {
        state.list.forEach((n) => { n.lu = true; });
      });
  },
});

export const { clearNotificationMessages } = notificationSlice.actions;
export default notificationSlice.reducer;